import { useState } from "react";
import { observer } from "mobx-react-lite";
import { notifyError } from "../../../../components/Errors/ErrorAlert";
import { createAlarmCode } from "../../../../core/api/responsecenters/alarmcodes";
import { ResponseCenterAlarmCodeDetails } from "../../../../core/api/responsecenters/types";
import { AlarmCodeForm } from "./AlarmCodeForm/AlarmCodeForm";
import { notify } from "../../../../ui-lib/components/Alerts/Toast";
import useTranslations from "../../../../core/i18n/useTranslations";
import useUser from "../../../../core/user/useUser";
import Button from "../../../../ui-lib/components/Button/Button";

const CreateAlarmCodeModal = ({
  responseCenterId,
  onAdd,
}: {
  responseCenterId: string | number;
  onAdd: () => void;
}) => {
  const t = useTranslations();
  const { authenticatedRequest } = useUser();

  const [modalOpen, setModalOpen] = useState(false);

  const labels = {
    title: t("AlarmReceptions:alarm_handling_alarm_codes_add"),
    description: t("AlarmReceptions:alarm_handling_alarm_codes_description"),
    submit: t("AlarmReceptions:alarm_handling_alarm_codes_add"),
  };

  const onSubmit = async (values: ResponseCenterAlarmCodeDetails) => {
    try {
      await createAlarmCode(responseCenterId, values, authenticatedRequest);

      notify({
        message: t("AlarmReceptions:alarm_handling_alarm_codes_add_success"),
      });
      onAdd();
      setModalOpen(false);
    } catch (error: any) {
      notifyError({
        error,
        t,
      });
    }
  };

  return (
    <>
      <Button
        size="small"
        variant="secondary"
        text={t("AlarmReceptions:alarm_handling_alarm_codes_add")}
        onClick={() => setModalOpen(true)}
      />
      <AlarmCodeForm
        isOpen={modalOpen}
        labels={labels}
        onSubmit={onSubmit}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
};

export default observer(CreateAlarmCodeModal);
